import { Skeleton } from 'antd'
import Styles from './TextChannels.module.scss'

export const LoadingSkeleton = () => {
  return (
    <div className={Styles.container}>
      <div className={Styles.item}>
        <Skeleton
          className={Styles.skeleton}
          active
          avatar={{ size: 'small', shape: 'circle' }}
          title
          paragraph={false}
        />
      </div>
      <div className={Styles.item}>
        <Skeleton
          className={Styles.skeleton}
          active
          avatar={{ size: 'small', shape: 'circle' }}
          title
          paragraph={false}
        />
      </div>
      <div className={Styles.item}>
        <Skeleton
          className={Styles.skeleton}
          active
          avatar={{ size: 'small', shape: 'circle' }}
          title
          paragraph={false}
        />
      </div>
    </div>
  )
}
